<template>
    <div class="string-filter">
        <div class="holder">
            <FilterTypeSelector
                :options="filterOptions"
                :default-filter="allFilters[0]"
                @input="onFilterType"
            />
            <AonInput
                v-model="filterValue"
                :disabled="filterType === 'Empty'"
                :placeholder="filterText"
                :data-cy="`filter.string-input`"
                search-input
                @update:modelValue="emitFilterObject"
                @clear="onClear"
            />
        </div>
    </div>
</template>

<script>
import FilterTypeSelector from './FilterTypeSelector.vue';
import AonInput from '@moatmetrics/armory/src/components/base/forms/AonInput.vue';
import { debounce } from 'lodash-es';

export default {
    name: 'StringFilter',
    components: {
        FilterTypeSelector,
        AonInput,
    },
    props: {
        columnName: {
            type: String,
            default: '',
        },
        columnLabel: {
            type: String,
            default: '',
        },
        defaultFilter: {
            type: [String, Object],
            default: () => null,
        },
        filters: {
            type: Array,
            default: () => [],
        },
        filterState: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            filterType: null,
            filterValue: null,
            filterSelectionOpen: false,
            filterTypeSelected: null,
            filterText: '',
            allFilters: [
                { itemText: 'Contains', itemValue: 'text_contains' },
                { itemText: 'Starts with', itemValue: 'starts_with' },
                { itemText: 'Word match', itemValue: 'word_match' },
                { itemText: 'Empty', itemValue: 'empty' },
            ],
        };
    },
    computed: {
        detail() {
            return {
                filterColumn: this.columnName,
                filterValue: this.filterValue ? this.filterValue.trim() : null,
                filterType: this.filterType,
                filterLabel: this.columnLabel,
                filter: 'string',
            };
        },
        defaultFilterVal() {
            return this.filterTypeSelected
                ? this.filterTypeSelected
                : this.defaultFilter
                ? this.defaultFilter
                : this.filterOptions[0];
        },
        filterOptions() {
            return this.filters && this.filters.length > 0
                ? this.filters
                : this.allFilters;
        },
    },
    watch: {
        filterState: {
            handler() {
                this.setupFilters();
            },
            deep: true,
        },
    },
    beforeMount() {
        this.setupFilters();
    },
    methods: {
        setupFilters() {
            if (!this.filterState) {
                this.clearFilter();

                return;
            }
            this.setFilter();
        },
        clearFilter() {
            this.filterValue = null;
            this.setFilterTypeInfo();
        },
        setFilterTypeInfo(val = null) {
            const filterVal = val ? val : this.defaultFilterVal;
            if (!filterVal) return;
            if (typeof filterVal === 'string') {
                this.filterTypeSelected = {
                    itemText: filterVal,
                    itemValue: filterVal.toLowerCase().replace(' ', '_'),
                };
            } else {
                this.filterTypeSelected = filterVal;
            }
            this.filterType = this.filterTypeSelected.itemText;
        },
        // param value: object { itemText: string, itemValue: string }
        onFilterType(value) {
            this.filterType = value.itemText;
            this.filterTypeSelected = value;
            if (this.filterType === 'Empty') {
                this.filterValue = null;
            }

            this.emitFilterObject();
        },
        onClear() {
            this.filterValue = null;
            this.$emit('onFilter', this.detail);
        },
        // TODO Investigate: this.filterValue = val; seems to occasionally throw an error in the runtime-core.esm-bundler.js:
        // TODO runtime-core.esm-bundler.js:988 Uncaught (in promise) TypeError: Cannot read properties of null (reading 'emitsOptions')
        // TODO L998 const emits = component.emitsOptions
        emitFilterObject: debounce(function (val) {
            this.filterValue = val;
            this.$emit('onFilter', this.detail);
        }, 500),
        setFilter() {
            this.clearFilter();
            this.setFilterTypeInfo(this.filterState.filterType);
            this.filterValue = this.filterState.filterValue;
        },
    },
};
</script>

<style lang="scss">
.string-filter {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;

    .bold {
        width: 100%;
    }

    .holder {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
    }
}
</style>
